<template>
	<div>
		<page-title-bar></page-title-bar>
		<v-container fluid grid-list-xl pt-0>
			<v-layout row wrap justify-end align-center>
				<v-flex xs12 md2>
					<v-text-field
					v-model.lazy="search"
					prepend-icon="search"
					label="Tìm kiếm"
					hide-details
					single-line
					></v-text-field>
				</v-flex>
				<v-flex xs12 md2>
					<v-menu
						:close-on-content-click="false"
						v-model="menu_month_picker"
						:nudge-right="40"
						lazy
						transition="scale-transition"
						offset-y
						full-width
						min-width="290px"
						:disabled="loading.getList"
					>
						<v-text-field
							slot="activator"
							v-model="chosen_month"
							label="Chọn tháng"
							:disabled="loading.getList"
							prepend-icon="event"
							readonly
							single-line
							hide-details
						></v-text-field>
						<v-date-picker
							min="2019-10"
							locale="vi-VI"
							type="month"
							v-model="chosen_month"
							@input="menu_month_picker = false"
						></v-date-picker>
					</v-menu>
				</v-flex>
				<v-flex xs12 md2>
					<v-select
						label="Tòa nhà"
						:disabled="loading.getList"
						v-model="chosen_building"
						:items="list_building"
						prepend-icon="domain"
						required
						hide-details
						single-line
					></v-select>
				</v-flex>
				<!-- In danh sách nợ -->
				<v-btn
					:disabled="loading.getList"
					@click="print_list_debt = true"
					color="primary"
				>
					<v-icon small left>print</v-icon>
					In danh sách nợ
				</v-btn>

				<v-btn :loading="export_csv.loading" @click="exportCSV" color="green" class="white--text">XUẤT EXCEL</v-btn>
				<export-csv-button
					:trigger="export_csv.trigger"
					:title="export_csv.title"
					:rows="export_csv.rows"
				></export-csv-button>
			</v-layout>
			<v-layout row wrap justify-center>
				<v-flex xs12>
					<v-card>
						<v-data-table
							disable-initial-sort
							:headers="headers"
							:items="items_filtered"
							:rows-per-page-items="rowPerPage"
							:loading="loading.getList"
						>
							<template #items="props">
								<tr>
									<td class="text-center">{{ props.item.room_id }}</td>
									<td class="text-center text-no-wrap">
										<span :class="['v-badge', status_color[props.item.status].color]">
											{{status_color[props.item.status].text}}
										</span>
									</td>
									<td class="text-center text-no-wrap">{{ props.item.total_bill | formatNumber }}</td>
									<td class="text-center">{{ props.item.collected_amount | formatNumber }}</td>
									<td class="text-center">{{ (props.item.total_bill - props.item.collected_amount) | formatNumber }}</td>
									<td class="text-center">{{ props.item.date_in | formatTimeServer}}</td>
									<td style="cursor: pointer" class="text-center">
											<v-edit-dialog
												large
												lazy
												@save="updateNote(props.item)"
												@open="props.item.new_note = props.item.note"
											>
											{{ props.item.note }}
											<template v-slot:input>
												<v-text-field
													:disabled="props.item.is_approved"
													v-model="props.item.new_note"
													label="Ghi chú"
													single-line
												></v-text-field>
											</template>
										</v-edit-dialog>
									</td>
									<td class="text-left text-no-wrap">
										<template v-if="props.item.diff">
											<v-checkbox
												:disabled="user_role !== 'admin' && user_role !== 'manager'"
												v-if="!props.item.loading"
												:label="props.item.is_approved ? 'Đã duyệt' : 'Chưa duyệt'"
												color="primary"
												v-model="props.item.is_approved"
												hide-details
												@change="updatePaymentApproval(props.item)"
											></v-checkbox>
											<v-progress-circular v-else color="primary" indeterminate size="24" class="ml-2"></v-progress-circular>
										</template>
										<span v-else>Đã thu đủ</span>
									</td>
								</tr>
							</template>
						</v-data-table>
					</v-card>
				</v-flex>
			</v-layout>
		</v-container>
		<print-portal
			layout="portrait"
			:open="print_list_debt"
			@close="print_list_debt = false"
		>
			<print-danh-sach-no :chosen_building="chosen_building" :payment_data="items"></print-danh-sach-no>
		</print-portal>
	</div>
</template>

<script>
import api from "Api";
import moment from "moment";
import {
	buildParamQuery,
	formatTimeServer,
} from "Helpers";
import { list_building } from "Constants/db-config";
import ExportCsvButton from 'Components/ExportExcel/ExportCsvButton'
import PrintDanhSachNo from "Components/Print/PrintDanhSachNo"
import PrintPortal from "Components/Print/PrintPortal"

export default {
	name: "danh-sach-no-tien-phong",
	components: {
		ExportCsvButton,
		PrintPortal,
		PrintDanhSachNo
	},
	data() {
		return {
			search: "",
			search_type: "roomId",
			headers: [
				{
					text: "Số phòng",
					align: "center",
					value: "room_id"
				},
				{
					text: "Trạng thái",
					align: "center",
					value: "status"
				},
				{ text: "Số tiền phải thu", align: "center", value: "total_bill" },
				{
					text: "Số tiền đã thu",
					align: "center",
					value: "collected_amount"
				},
				{ text: "Còn lại", align: "center", value: "diff" },
				{ text: "Ngày nhận phòng", align: "center", value: "date_in", sortable: false },
				{ text: "Giải trình", align: "center", value: "note", sortable: false },
				{
					text: "Cô Gấm duyệt",
					align: "left",
					value: "water_price",
					sortable: false
				}
			],
			list_building : [
				...list_building,
				{text: 'Tất cả', value: ''}

			],
			list_search_type: [
				{ text: "Số phòng", value: "roomId" },
				{ text: "Tên khách hàng", value: "name" },
				{ text: "Biển số xe", value: "motorbike" }
			],
			chosen_building: "",
			items: [],
			loading: {
				submit: false,
				getDetail: false,
				getList: false
			},
			rowPerPage: [20, 50, 100, { text: "Tất cả", value: -1 }],
			menu_month_picker: false,
			chosen_month: moment().subtract(1, 'months').toISOString().substr(0, 7),
			status_color: {
				"eq": {
					text: "Đã thu đủ",
					textColor: 'white',
					color: "primary"
				},
				"lt": {
					text: "Nợ tiền phòng",
					textColor: 'black',
					color: "warning"
				},
				"gt": {
					text: "Thu dư",
					textColor: 'black',
					color: "cyan"
				},
				"approved": {
					text: "Đã duyệt",
					textColor: 'black',
					color: "primary"
				}
			},
			export_csv: {
				loading: false,
				trigger: false,
				title: "",
				rows: []
			},
			print_list_debt: false
		};
	},
	computed: {
		user_role(){
			return this.$store.state.auth.role
		},
		items_filtered(){
			if (!this.search) return this.items.slice(0);

			const searchArray = this.search.toLowerCase().split(' ')
			
			if (searchArray.length > 1){
				return this.items.filter(item => item.room_id && searchArray.includes(item.room_id.toLowerCase()))
			}

			const search = searchArray[0];

			return this.items.filter(item => {
					if (
							item.building && item.room_id
							&& item.building.includes(this.chosen_building) && item.room_id.toLowerCase().includes(search)
					)
							return true
					if (item.month.includes(search))
							return true
					return false
			})
			}
	},
	watch: {
		chosen_building(){
			this.getTablesData()
		},
		chosen_month(){
			this.getTablesData()
		},
	},
	mounted() {
		this.getTablesData();
	},
	methods: {
		getTablesData: async function() {
			this.loading.getList = true;
			const last_date_of_month = this.getLastDateOfChosenMonth(this.chosen_month);
			const params = {
				building: this.chosen_building,
				[this.search_type]: this.search,
				lastDateOfMonth: last_date_of_month.clone().endOf("month").toISOString()
			};
			const query = buildParamQuery(params);
			let data = await api.getChargeRoom(query);
			this.loading.getList = false;
			if (data.status === 200 && data.data.is_saved_payment) {
				this.items = data.data.paymentData
					.map(room => this.handleData(room))
			}
		},
		handleData: function(payment) {
			// Handle payment status
			payment.diff = payment.total_bill - payment.collected_amount
			payment.loading = false
			payment.status =
				payment.diff > 0
					// Thu thiếu
					? "lt"
					// Thu dư
					: payment.diff < 0
					? "gt"
					// Thu đủ
					: "eq";
			payment.status = payment.is_approved ? "approved" : payment.status;
			return payment;
		},
		getLastDateOfChosenMonth(chosen_month) {
			const start_date = new Date(chosen_month + "-01");
			return moment(start_date).endOf("month");
		},
        updateNote: async function (payment){
            const old_note = payment.note
			const _id = payment._id
			const data = await api.updateReceipt(`/payments/${payment._id}`, { note: payment.new_note });
            if (data.status == 200){
				this.$set(payment, 'note', payment.new_note);
                swal.fire('Thành công', 'Cập nhật giải trình thành công', 'success')
            } else {
                payment.note = old_note
                swal.fire('Thất bại', data.message, 'error')
            }
		},
		updatePaymentApproval: async function (payment){
			payment.loading = true
			const data = await api.updateReceipt(`/payments/${payment._id}`, { is_approved: payment.is_approved });
			payment.loading = false
			if (data.status == 200){
				payment = this.handleData(payment)
                // swal.fire('Thành công', 'Cập nhật giải thích thành công', 'success')
            } else {
                payment.is_approved = !payment.is_approved
                // swal.fire('Thất bại', data.message, 'error')
            }
		},
		exportCSV: function(){
			const rows = this.items.map(item => {
				return {
					"Tòa nhà": item.building,
					"Số phòng": item.room_id,
					"Trạng thái": this.status_color[item.status].text,
					"Số tiền phải thu": item.total_bill,
					"Số tiền đã thu": item.collected_amount,
					"Còn lại": item.total_bill - item.collected_amount,
					"Giải trình": item.note,
					"Cô Gấm duyệt": item.diff ? item.is_approved ? 'Đã duyệt' : 'Chưa duyệt' : "Đã thu đủ",
				}
			})
			this.export_csv.rows = rows;
			this.export_csv.title = "ds-no-tien-phong-" + this.chosen_month;
			this.export_csv.trigger = !this.export_csv.trigger;
		}
	}
};
</script>
